<template>
    <a-spin :spinning="loading.container">
        <a-card :bordered="false" class="list">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" ref="forum-search-form">
                    <a-row :gutter="16" type="flex">
                        <a-col :span="24">
                            <a-row type="flex">
                                <a-form-item :label="language['businessGroupName']">
                                    <a-select v-model="params.group_id"
                                        style="width: 220px;margin-right: 16px;"
                                        @change="handleDepartmentGroupChange">
                                        <a-select-option :value="0"> {{ language['ispforum.all'] }} </a-select-option>
                                        <a-select-option v-for="group in department.group"
                                            :key="group.id"
                                            :value="group.id">
                                            {{ group.departName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                                <a-form-item :label="language['businessUnitName']">
                                    <a-select v-model="params.department_id"
                                        style="width: 220px;"
                                        @change="handleDepartmentGroupChange">
                                        <a-select-option :value="0">{{ language['ispforum.all'] }}</a-select-option>
                                        <a-select-option v-for="place in department.selectedPlace"
                                            :key="place.id"
                                            :value="place.id">
                                            {{ place.departName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-row>
                        </a-col>
                    </a-row>
                    <a-row :gutter="32" type="flex" style="margin-bottom: 48px">
                        <a-col :span="24">
                            <a-row type="flex">
                                <a-form-item :label="language['ispforum.statisticalInterval']">
                                    <a-radio-group v-model="params.cate">
                                        <a-row tpye="flex" align="middle" style="margin-bottom: 16px">
                                            <a-radio :value="1">{{ language['ispforum.yearStatistics'] }}</a-radio>
                                            <a-select v-model="params.year"
                                                style="margin-left: 16px;width: 120px">
                                                <a-select-option v-for="year in years"
                                                    :key="year"
                                                    :value="year">
                                                    {{ year }}
                                                </a-select-option>
                                            </a-select>
                                        </a-row>
                                        <a-row type="flex" align="middle">
                                            <a-radio :value="2">{{ language['ispforum.monthlyStatistics'] }}</a-radio>
                                            <a-month-picker
                                                v-model="date.stime"
                                                format="YYYY-MM"
                                                style="margin-right: 16px"
                                                :placeholder="language['trmorder.beginTime']" />
                                            <a-month-picker
                                                v-model="date.etime"
                                                format="YYYY-MM"
                                                :placeholder="language['trmorder.endTime']" />
                                        </a-row>
                                    </a-radio-group>
                                </a-form-item>
                            </a-row>
                        </a-col>
                    </a-row>
                    <a-row :gutter="32" type="flex">
                        <a-col :span="24">
                            <a-row type="flex">
                                <a-form-item :label="language['ispforum.generateIcon']">
                                    <a-radio-group v-model="params.chart_type">
                                        <a-row tpye="flex" align="middle" style="margin-bottom: 16px">
                                            <a-radio :value="1">{{ language['ispforum.statistics'] + '(Excel' + language['ispforum.files2'] + ')' }}</a-radio>
                                        </a-row>
                                        <a-row tpye="flex" align="middle">
                                            <a-radio :value="2">{{ language['ispforum.summaryGraph'] + '(PDF' + language['ispforum.files2'] + ')' }}</a-radio>
                                            <a-checkbox v-model="params.group_enable">
                                                {{ language['ispforum.BGstatistics'] }}
                                            </a-checkbox>
                                            <a-checkbox v-model="params.department_enable">
                                                {{ language['ispforum.statisticalBUDivisionBG'] }}
                                            </a-checkbox>
                                            <a-checkbox v-model="params.section_enable">
                                                {{ language['ispforum.statisticalDivisionBU'] }}
                                            </a-checkbox>
                                        </a-row>
                                    </a-radio-group>
                                </a-form-item>
                            </a-row>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top: 24px;">
                        <a-col :span="24">
                            <a-form-item label="">
                                <a-button type="primary" @click="handleExec"> {{ language['ispforum.implement'] }}  </a-button>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-card>
    </a-spin>
</template>

<script>
import { queryDepartTreeList } from '@/api/api'
import { downFile } from '@/api/manageExtend'

export default {
    data() {
        return {
            department: {
                group: {},
                place: {},
                selectedPlace: []
            },
            date: {
                stime: null,
                etime: null
            },
            params: {
                group_id: 0,
                department_id: 0,
                cate: 2,
                year: new Date().getFullYear(),
                start_date: null,
                end_date: null,
                chart_type: 1,
                type: 3,
                group_enable: false,
                department_enable: false,
                section_enable: false
            },
            years: [],
            loading: {
                container: false,
                department: false
            }
        }
    },
    computed: {
        language() {
            return this.$store.getters.language
        },
    },
    created() {
        this.getDepartment()
        this.getYears()
    },
    methods: {
        // 获取部门信息
        getDepartment() {
            if (this.loading.department) return
            this.loading.department = true
            queryDepartTreeList({applicationCode: 'ipsys'}).then((res) => {
                if (res.success) this.parseDepartment(res.result)
                this.loading.department = false
                this.$forceUpdate()
            })
        },
        // 解析部门数据 ( 仅获取事业群与事业处 )
        parseDepartment(list) {
            for (let i = 0, l = list.length; i < l; i++) {
                const cur = list[i]
                const children = JSON.parse(JSON.stringify(cur.children))
                delete cur.children
                // group
                if (parseInt(cur.orgType) === 2) this.department.group[cur.id] = cur
                // place
                if (parseInt(cur.orgType) === 3) {
                    if (cur.parentId) {
                        if (!this.department.place[cur.parentId]) {
                            this.department.place[cur.parentId] = []
                        }
                        this.department.place[cur.parentId].push(cur)
                    }
                }
                if (children && children.length > 0) this.parseDepartment(children)
            }
        },
        // 变更事业群的选择
        handleDepartmentGroupChange(value) {
            if (
                value &&
                this.department.place[value]
            ) {
                this.department.selectedPlace = this.department.place[value]
                this.$forceUpdate()
            }
        },
        // 年份
        getYears() {
            const s = 1970
            const e = new Date().getFullYear()
            for (let i = e; i >= s; i--) {
                this.years.push(i)
            }
            this.$forceUpdate()
        },
        // 月份格式
        handleMonthFormat(date) {
            const m = date.month() + 1
            return m > 10 ? m.toString() : `0${m}`
        },
        //执行
        handleExec() {
            let flag = false
            if (this.params.cate === 2) {
                // 月统计校验
                if (
                    !this.date.stime ||
                    !this.date.etime
                ) {
                    this.$message.error(this.language['ispforum.timeWarn1'])
                    return
                }
                const stime = this.date.stime
                const etime = this.date.etime
                if (stime.year() !== etime.year()) {
                    this.$message.error(this.language['ispforum.timeWarn2'])
                    return
                }
                if (stime.month() > etime.month()) {
                    this.$message.error(this.language['ispforum.timeWarn3'])
                    return
                }
                this.params.start_date = stime.year() + '-' + this.handleMonthFormat(stime)
                this.params.end_date = etime.year() + '-' + this.handleMonthFormat(etime)
                flag = true
            } else flag = true
            const params = {
                group_enable: this.params.group_enable ? 1 : 0,
                department_enable: this.params.department_enable ? 1 : 0,
                section_enable: this.params.section_enable ? 1 : 0
            }
            this.loading.container = true

            // downFile('/v1/getStatistc', {
            // ...this.params,
            // ...params,
            // }).then((res) => {
            // this.loading.container = false
            // if (!res) {
            //     this.$message.warning('文件下载失败')
            //     return
            // }
            // let fileName = '讨论贡献报表'
            // if (typeof window.navigator.msSaveBlob !== 'undefined') {
            //     window.navigator.msSaveBlob(new Blob([responseType], { type: 'application/vnd.ms-excel' }, fileName))
            // } else {
            //     let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
            //     let link = document.createElement('a')
            //     link.style.display = 'none'
            //     link.href = url
            //     link.setAttribute('download', fileName) // 也可使用 link.download = fileName 定义下载文件名
            //     document.body.appendChild(link)
            //     link.click()
            //     document.body.removeChild(link) //下载完成移除元素
            //     window.URL.revokeObjectURL(url) //释放掉blob对象
            // }
            // }).finally(() => {
            //     this.loading.container = false
            // })
            // return

            if (flag) {
                downFile('/v1/getStatistc', {
                    ...this.params,
                    ...params
                }).then((res) => {
                    const vm = this
                    if (res instanceof Blob) {
                        const reader = new FileReader()
                        reader.readAsBinaryString(res)
                        reader.onload = function() {
                            vm.loading.container = false
                            const response = JSON.parse(this.result)
                            if (response.code === 200) {
                                const a = document.createElement('a')
                                a.href = response.result.url
                                if (vm.params.chart_type === 1) a.download
                                if (vm.params.chart_type === 2) a.target = '_blank'
                                a.click()
                            } else vm.$message.error(this.language['ispforum.timeWarn4'])
                        }
                    } else this.loading.container = false
                })
            } else this.loading.container = false
        }
    }
}
</script>